import React, { useState } from "react";
import emailjs from "emailjs-com";
import "./Contact.css";

function Contact() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    practiceArea: "",
    message: "",
  });

  const [isSent, setIsSent] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const serviceID = "service_iwbk54c";
    const templateID = "template_v8uuykb";
    const userID = "OhcaZYlqhsBG_tZwe";

    emailjs
      .send(serviceID, templateID, formData, userID)
      .then((response) => {
        console.log("Email sent successfully!", response.status, response.text);
        setIsSent(true);
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          practiceArea: "",
          message: "",
        });
      })
      .catch((err) => {
        console.error("Failed to send email:", err);
      });
  };

  return (
    <div className="consultation-container">
      <div className="consultation-card">
        {/* Left Section with Logo */}
        <div className="left-section">
          <div className="logo-container">
            <img src="logo.PNG" alt="Company Logo" className="company-logo" />
            <span className="trademark-symbol">®</span>
          </div>
          <h2 className="company-name">ALLIANCE LAW GROUP</h2>
        </div>

        {/* Right Section with Form */}
        <div className="right-section">
          <h2 className="form-title">Get in touch to book a legal consultation</h2>

          {/* Visit Us Section */}
          <div className="visit-us-section">
            <h3 className="visit-heading">📍 Visit Us</h3>
            <div className="visit-tile">
              <p className="visit-detail">
                <strong>Address:</strong><br />
                C-59, Block C, Neeti Bagh,<br />
                New Delhi, Delhi 110049
              </p>
              <p className="visit-detail">
                <strong>Email:</strong><br />
                <a href="mailto:contact@alliancelawgroup.com" className="visit-email">
                info@alliancelawgroup.in
                </a>
              </p>
            </div>
          </div>

          {isSent && <p className="success-message">Email sent successfully!</p>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                name="firstName"
                placeholder="First name *"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="lastName"
                placeholder="Last name *"
                value={formData.lastName}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder="Email *"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <input
                type="tel"
                name="phone"
                placeholder="Phone Number *"
                value={formData.phone}
                onChange={handleChange}
                required
              />
              <select
                name="practiceArea"
                value={formData.practiceArea}
                onChange={handleChange}
                required
              >
                <option value="">Choose practice area</option>
                <option value="corporate">Corporate Law</option>
                <option value="criminal">Criminal Law</option>
                <option value="family">Family Law</option>
                <option value="property">Property Law</option>
                <option value="civil">Civil Law</option>
                <option value="commercial">Commercial Law</option>
              </select>
            </div>

            <textarea
              name="message"
              placeholder="Message"
              value={formData.message}
              onChange={handleChange}
            ></textarea>

            <div className="form-actions">
              <button type="submit" className="submit-button">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Contact;
